// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gW","h5Button":"gW","button":"gX","block":"gY","btnDefault":"gZ","disable":"g0","btnPrimary":"g1"};